import ApplicationController from './application_controller'
import debounce from 'lodash/debounce'

/**
 * GOAL: Click on a button
 */
export default class extends ApplicationController {
  static targets = ['button']
  static values = {
    enableDebounce: { type: Boolean, default: false },
    wait: { type: Number, default: 1000 },
    autoClickOnConnect: { type: Boolean, default: false }
  }

  connect() {
    if (this.enableDebounceValue) {
      this.call = debounce(this.call, this.waitValue).bind(this)
    }
    
    if (this.autoClickOnConnectValue) {
      setTimeout(() => this.call(), 100)
    }
  }

  call() {
    this.buttonTarget.click()
  }
}
